import { z } from "zod";

export const reinterventionSiteCommentLinkDtoSchema = z.object({
  comment: z.string().nullable(),
  csLinkId: z.number(),
  location: z.string().nullable(),
});

export const reinterventionSiteCommentDtoSchema = z.object({
  description: z.string().nullish(),
  comment: z.string().nullable(),
  creationDateTime: z.coerce.date().nullable(),
  refReinterventionGlobalReasonId: z.number().nullable(),
  siteId: z.number(),
  links: z.array(reinterventionSiteCommentLinkDtoSchema),
});

export type TReinterventionSiteCommentDto = z.infer<typeof reinterventionSiteCommentDtoSchema>;
export type TReinterventionSiteCommentLinkDto = z.infer<typeof reinterventionSiteCommentLinkDtoSchema>;
